import { render } from "./ResponsibleModal.vue?vue&type=template&id=bb2376ac&lang=html"
import script from "./ResponsibleModal.vue?vue&type=script&lang=js"
export * from "./ResponsibleModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__